import { render, staticRenderFns } from "./top-banner.vue?vue&type=template&id=74d2908b&"
import script from "./top-banner.vue?vue&type=script&lang=ts&"
export * from "./top-banner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports